import { MouseEventHandler, useState } from "react";
import { LuCopy, LuCopyCheck } from "react-icons/lu";

import { cn, sleep } from "@bentolabs/kit/utils";
import { useCopyToClipboard } from "usehooks-ts";
import { Address } from "viem";
import { useAccount } from "wagmi";

import { shortAddress } from "shared/web3/utils";

type Props = {
  address: Address;
  className?: string;
  copyable?: boolean;
  addressClassName?: string;
  copyIconClassName?: string;
  iconWrapperClassName?: string;
};

export const AddressLink = (props: Props) => {
  const {
    className,
    address,
    addressClassName,
    copyIconClassName,
    iconWrapperClassName,
    copyable = false,
  } = props;
  const { chain } = useAccount();
  const [isCopied, setIsCopied] = useState(false);
  const [_, copy] = useCopyToClipboard();
  const handleCopy: MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsCopied(true);
    await copy(address);
    await sleep(1000);
    setIsCopied(false);
  };

  const copyCls = cn("size-3", copyIconClassName);
  const explorerLink = chain?.blockExplorers?.default
    ? `${chain.blockExplorers.default.url}/token/${address}`
    : ``;

  return (
    <div
      className={cn(
        "flex cursor-pointer items-center transition-colors",
        "text-ironside-grey gap-x-0.5 text-xs",
        className
      )}
    >
      <a
        target="_blank"
        referrerPolicy="no-referrer"
        href={explorerLink}
        className={cn("inline-flex hover:brightness-125", addressClassName)}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {shortAddress(address, 6, 5)}
      </a>
      {copyable && (
        <button
          disabled={isCopied}
          className={cn(
            "inline-flex cursor-pointer items-center justify-center p-1 outline-hidden hover:brightness-125",
            iconWrapperClassName
          )}
          onClick={handleCopy}
        >
          {isCopied ? (
            <LuCopyCheck className={copyCls} />
          ) : (
            <LuCopy className={copyCls} />
          )}
        </button>
      )}
    </div>
  );
};
